import { Controller } from "@hotwired/stimulus";
import Decimal from "decimal.js";
import { appCurrency } from "../utils/currency";

export default class extends Controller<HTMLFormElement> {
  static values = {
    total: Number,
  };

  declare totalValue: number;
  declare readonly hasTotalValue: boolean;

  static targets = [
    "amount",
    "container",
    "deleteButton",
    "row",
    "remaining",
    "remainingContainer",
    "template",
  ];

  declare readonly hasDeleteButtonTarget: boolean;
  declare readonly deleteButtonTarget: HTMLButtonElement;
  declare readonly deleteButtonTargets: HTMLButtonElement[];

  declare readonly hasContainerTarget: boolean;
  declare readonly containerTarget: HTMLElement;
  declare readonly containerTargets: HTMLElement[];

  declare readonly hasRowTarget: boolean;
  declare readonly rowTarget: HTMLElement;
  declare readonly rowTargets: HTMLElement[];

  declare readonly hasTemplateTarget: boolean;
  declare readonly templateTarget: HTMLTemplateElement;
  declare readonly templateTargets: HTMLTemplateElement[];

  declare readonly hasRemainingTarget: boolean;
  declare readonly remainingTarget: HTMLElement;
  declare readonly remainingTargets: HTMLElement[];

  declare readonly hasRemainingContainerTarget: boolean;
  declare readonly remainingContainerTarget: HTMLElement;
  declare readonly remainingContainerTargets: HTMLElement[];

  declare readonly hasAmountTarget: boolean;
  declare readonly amountTarget: HTMLInputElement;
  declare readonly amountTargets: HTMLInputElement[];

  refreshButtonsStatus() {
    const disabled = this.deleteButtonTargets.length === 1;
    this.deleteButtonTargets.forEach((button) => {
      button.disabled = disabled;
    });
  }

  connect(): void {
    this.refreshButtonsStatus();
    this.refreshRemaining();
  }

  categoryChanged() {
    const form = this.element;
    const selects = form.querySelectorAll(
      '[name="[]category"]'
    ) as NodeListOf<HTMLSelectElement>;
    if (selects.length === 1) {
      form.requestSubmit();
    }
  }

  amountChanged() {
    this.refreshRemaining();
  }

  refreshRemaining() {
    const soFar = this.amountTargets.reduce((acc, input) => {
      let value: Decimal;
      try {
        value = new Decimal(appCurrency(input.value).value);
      } catch (e) {
        console.info("invalid input", e);
        return acc;
      }

      if (value.isNaN()) {
        return acc;
      }

      return acc.add(value);
    }, new Decimal(0));
    const total = new Decimal(this.totalValue);
    const remaining = total.sub(soFar);
    this.remainingTarget.textContent = remaining.toString();
    this.remainingContainerTarget.toggleAttribute(
      "data-categorise-balanced",
      remaining.isZero()
    );
  }

  addCategory() {
    const newItem = document.importNode(this.templateTarget.content, true);
    this.containerTarget.appendChild(newItem);

    this.refreshButtonsStatus();
  }

  removeCategory(event: Event) {
    const target = event.currentTarget as HTMLButtonElement;

    const index = this.deleteButtonTargets.indexOf(target);

    this.rowTargets[index].remove();

    this.refreshButtonsStatus();
  }
}
